export default {
  getStorage(key) {
    let obj = JSON.parse(sessionStorage.getItem(key))
    return obj
  },
  setStorage(key, value) {
    let valueStr = JSON.stringify(value)
    sessionStorage.setItem(key, valueStr)

  }
}